var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "lead-list-page" } }, [
    _vm.showTitle
      ? _c("h3", { staticClass: "title" }, [_vm._v("Meta Leads")])
      : _vm._e(),
    _vm._v(" "),
    _vm.checkboxOption.selectedRowKeys.length
      ? _c("div", { staticClass: "selection-bar" }, [
          _c(
            "section",
            { staticClass: "uncheck", on: { click: _vm.unselectAll } },
            [
              _c("span", { staticClass: "material-icons" }, [
                _vm._v(" arrow_back "),
              ]),
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$t("chatbotv2.uncheckAll")) +
                  "\n        "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "section",
            { staticClass: "select", on: { click: _vm.selectAll } },
            [_vm._v(_vm._s(_vm.$t("chatbotv2.selectAll")))]
          ),
          _vm._v(" "),
          _c(
            "section",
            { staticClass: "select", on: { click: _vm.deleteAll } },
            [_vm._v("Delete All")]
          ),
          _vm._v(" "),
          _c("section", { staticClass: "queries" }, [
            _vm._v(
              "\n            +" +
                _vm._s(
                  _vm.checkboxOption.selectedRowKeys.length +
                    " " +
                    _vm.$t("wp.contactSelected")
                ) +
                "\n        "
            ),
          ]),
          _vm._v(" "),
          _c(
            "section",
            { staticClass: "actions" },
            [
              _c(
                "a-button",
                { staticClass: "d-none", attrs: { ghost: "", disabled: "" } },
                [_vm._v(_vm._s(_vm.$t("wp.sendBroadcastMessage")))]
              ),
            ],
            1
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "toolbox" }, [
      _c("div", [_vm._t("left-actions")], 2),
      _vm._v(" "),
      _c("div", [_vm._t("middle-actions")], 2),
      _vm._v(" "),
      _c("div", { staticClass: "buttons" }),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "table-wrapper" },
      [
        _c("div", { staticClass: "toolbar" }, [
          _c(
            "div",
            { staticClass: "toolbar-filter" },
            [
              _c("a-input-search", {
                staticClass: "row search-input",
                staticStyle: { width: "300px" },
                attrs: { placeholder: _vm.$t("message.startFilter") },
                on: {
                  input: function ($event) {
                    return _vm.onSearch($event.target.value)
                  },
                },
                model: {
                  value: _vm.searchText,
                  callback: function ($$v) {
                    _vm.searchText = $$v
                  },
                  expression: "searchText",
                },
              }),
              _vm._v(" "),
              _c("CommonFilterTool", {
                attrs: {
                  "keep-state-on-query-params": false,
                  "filter-meta": _vm.filterMetas,
                  "label-formatter": _vm.filterLabelFormatter,
                },
                on: { addFilter: _vm.addFilter },
                model: {
                  value: _vm.breakdownFilter,
                  callback: function ($$v) {
                    _vm.breakdownFilter = $$v
                  },
                  expression: "breakdownFilter",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c(
                "SupsisButton",
                {
                  attrs: { ghost: "", primary: "" },
                  on: { click: _vm.syncLeads },
                },
                [
                  _c("i", { staticClass: "material-icons" }, [_vm._v("sync")]),
                  _vm._v(" Sync Leads\n                "),
                ]
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("SupsisTable", {
          attrs: {
            columns: _vm.getCols(),
            rows: _vm.leads,
            "top-pagination": "",
            "empty-data-bordered": "",
            "bottom-pagination": "",
            "pagination-cursor": _vm.pagination,
            options: {
              checkboxOption: _vm.checkboxOption,
              rowStyleOption: _vm.rowStyleOption,
              clipboardOption: _vm.clipboardOption,
              fixedHeader: true,
              id: "leads-table",
              borderX: true,
              borderY: true,
            },
          },
          on: {
            "cursor-changed": function (cursor) {
              return (_vm.pagination = cursor)
            },
          },
        }),
        _vm._v(" "),
        _vm.forbidden
          ? _c("NoMessage", {
              attrs: {
                title: "Forbidden Channel",
                desc: "You are not allowed to see this channel",
              },
            })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }